import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, withModifiers as _withModifiers, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56fde2b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "create-work-form-wrapper",
  "data-testid": "create-work"
}
const _hoisted_2 = {
  class: "row no-space",
  "data-testid": "is-original-push-buttons"
}
const _hoisted_3 = { class: "col-4 radio-container" }
const _hoisted_4 = { class: "label" }
const _hoisted_5 = {
  class: "row no-space",
  "data-testid": "work-alternative-titles"
}
const _hoisted_6 = { class: "col-10" }
const _hoisted_7 = {
  class: "row no-space",
  "data-testid": "work-writers"
}
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = {
  class: "row no-space",
  "data-testid": "work-samples"
}
const _hoisted_10 = { class: "col-10" }
const _hoisted_11 = { class: "row no-space justify-end" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "row no-space" }
const _hoisted_14 = { class: "col-7" }
const _hoisted_15 = {
  class: "col-12 no-space create-work-form-wrapper",
  "data-testid": "create-work-loader"
}

import { computed, ref, toRefs } from 'vue'
import { useForm, ErrorMessage } from 'vee-validate'
import { useRoute } from 'vue-router'
import { useGettext } from 'vue3-gettext'
import WorkSamples from '@/components/AddWork/WorkSamples.vue'
import WorkWriters from '@/components/AddWork/WorkWriters.vue'
import PushButtons from '@/components/CommonUI/PushButtons.vue'
import IconUI from '@/components/CommonUI/IconUI.vue'
import NotificationUI from '@/components/CommonUI/NotificationUI.vue'
import AlternativeTitles from '@/components/AddWork/AlternativeTitles.vue'
import LoaderUI from '@/components/CommonUI/LoaderUI.vue'
import UserDetailsConfirmationDialog from '@/components/AddWork/UserDetailsConfirmationDialog.vue'
import WorkRoyaltiesTermsDialog from '@/components/AddWork/WorkRoyaltiesTermsDialog.vue'
import UpgradeDialog from '@/components/UpgradeDialog.vue'
import { formatTrackDurationToString } from '@/helpers/tracks'
import {
  emptyAlternativeTitle,
  emptySample,
  emptyWriter,
} from '@/constants'
import { isApiErrorResponse, formatWorksApiErrors } from '@/helpers/api'
import { useWorksStore } from '@/store/works'
import { useTracksStore } from '@/store/tracks'
import { useUserStore } from '@/store/user'
import workSchema from '@/components/ValidationSchemas/work'
import { fireOpenNextTrackEvent } from '@/events/createWork'

interface Props {
  track: Track,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateWork',
  props: {
    track: {}
  },
  emits: ["cancel"],
  setup(__props: any, { emit }) {

const props = __props;


const { track } = toRefs(props)


const { $gettext } = useGettext()
const route = useRoute()
const workStore = useWorksStore()
const trackStore = useTracksStore()
const userStore = useUserStore()

const isOriginalTrack = ref(false)
const isCreatingWorkLoading = ref(false)
const noSubscriptionDialog = ref<InstanceType<typeof UpgradeDialog> | null>(null)
const subscriptionError = ref<null | SubscriptionError>(null)
const userDetailsConfirmationDialog = ref<InstanceType<typeof UserDetailsConfirmationDialog> | null>(null)
const workRoyaltiesTermsDialog = ref<InstanceType<typeof WorkRoyaltiesTermsDialog> | null>(null)

const trackDurationString = formatTrackDurationToString(track.value.duration)

const emptyWork: WorkForm = {
  release_id: Number(route.params.releaseId),
  release_track_id: track.value.id,
  duration: trackDurationString,
  alternative_titles: [
    emptyAlternativeTitle,
  ],
  writers: [
    emptyWriter,
  ],
  samples: [
    emptySample,
  ],
  societies: [],
  hasSamples: false,
}

const { errors, handleSubmit, setErrors, values } = useForm({
  validationSchema: workSchema(track.value.title),
  initialValues: emptyWork,
})

const isSubmitDisabled = computed(() => !!Object.keys(errors.value).length)

async function createWork(work: WorkForm) {
  try {
    isCreatingWorkLoading.value = true

    await workStore.createWork(work)
    fireOpenNextTrackEvent(track.value.id, trackStore.tracks || [])

    workStore.$patch({
      worksCount: Number(workStore.worksCount) + 1,
    })
    trackStore.removeTrack(track.value.id)
  } catch (error) {
    if (isApiErrorResponse(error)) {
      const errors = formatWorksApiErrors(error as ApiResponseError)

      setErrors(errors)

      if (errors.missing_subscription) {
        subscriptionError.value = errors.missing_subscription
        noSubscriptionDialog.value?.show()
      }
    }

    isCreatingWorkLoading.value = false
  }
}

function termsConfirmed(values: WorkForm) {
  const isWriterCurrentUser = values.writers
    .some(writer => writer.email.trim().toLowerCase() === userStore.userDetails?.emailAddress.trim().toLowerCase())

  if (isWriterCurrentUser && userStore.userDetails?.isReviewDetailsDisplayable) {
    userDetailsConfirmationDialog.value?.show()

    return
  }

  createWork(values)
}

const onSubmit = handleSubmit((values: WorkForm) => {
  if (userStore.isRlsSubscription() && workStore.worksCount === 0) {
    workRoyaltiesTermsDialog.value?.show()

    return
  }

  termsConfirmed(values)
})

return (_ctx: any,_cache: any) => {
  const _directive_translate = _resolveDirective("translate")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, [
            _withDirectives((_openBlock(), _createElementBlock("span", null, [
              _createTextVNode("Is this an Original Musical Work?")
            ])), [
              [_directive_translate]
            ]),
            _withDirectives(_createVNode(IconUI, {
              class: "tooltip-icon",
              name: "tooltip",
              fill: "info",
              "data-testid": "is-original-track-tooltip"
            }, null, 512), [
              [_directive_tippy, { content: _unref($gettext)('You can only register claims on Musical Works when you have been directly involved in their creation. For example, as a songwriter/lyricist, composer/producer or arranger. You cannot register claims to cover versions of existing Musical Works.') }]
            ])
          ]),
          _createVNode(PushButtons, {
            modelValue: isOriginalTrack.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isOriginalTrack).value = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)), ["prevent"]))
        }, [
          _createVNode(_unref(ErrorMessage), { name: "0" }, {
            default: _withCtx(({ message }) => [
              _createVNode(NotificationUI, {
                message: message,
                type: "error outline",
                "icon-fill": "error",
                "icon-name": "danger"
              }, null, 8, ["message"])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(AlternativeTitles)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(WorkWriters, { track: _unref(track) }, null, 8, ["track"])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(WorkSamples)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _withDirectives((_openBlock(), _createElementBlock("button", {
              class: "button black cancel-button",
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('cancel')))
            }, [
              _createTextVNode(" Cancel ")
            ])), [
              [_directive_translate]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("button", {
              class: "button",
              type: "button",
              disabled: isSubmitDisabled.value,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)))
            }, [
              _createTextVNode(" Save edits ")
            ], 8, _hoisted_12)), [
              [_directive_translate]
            ])
          ])
        ], 32),
        _createVNode(UpgradeDialog, {
          ref_key: "noSubscriptionDialog",
          ref: noSubscriptionDialog,
          "data-testid": "noSubscriptionDialog",
          dismissible: ""
        }, null, 512)
      ], 512), [
        [_vShow, isOriginalTrack.value]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(NotificationUI, {
            message: _unref($gettext)('You can only register tracks that you have composed.'),
            "icon-name": "info",
            type: "warning outline",
            "icon-fill": "warning"
          }, null, 8, ["message"])
        ])
      ], 512), [
        [_vShow, !isOriginalTrack.value]
      ])
    ], 512), [
      [_vShow, !isCreatingWorkLoading.value]
    ]),
    _createVNode(WorkRoyaltiesTermsDialog, {
      ref_key: "workRoyaltiesTermsDialog",
      ref: workRoyaltiesTermsDialog,
      onConfirm: _cache[4] || (_cache[4] = ($event: any) => (termsConfirmed(_unref(values))))
    }, null, 512),
    _createVNode(UserDetailsConfirmationDialog, {
      ref_key: "userDetailsConfirmationDialog",
      ref: userDetailsConfirmationDialog,
      onSave: _cache[5] || (_cache[5] = ($event: any) => (createWork(_unref(values))))
    }, null, 512),
    _withDirectives(_createElementVNode("div", _hoisted_15, [
      _createVNode(LoaderUI, { "ditto-plus": "" })
    ], 512), [
      [_vShow, isCreatingWorkLoading.value]
    ])
  ]))
}
}

})